import type { CouponId } from '../../../../schema/coupon/entry.js';
import type { IGetCouponsUseCase } from '../../../domain/entry.js';

export type IGetCouponsController = ReturnType<typeof getCouponsController>;

type ControllerArgs = { couponId: CouponId };

/**
 * Controller for subscribe to a coupon model.
 *
 * @param getCouponsUseCase Use case for getting coupons collection
 * @returns Controller executor function
 */
export function getCouponsController(getCouponsUseCase: IGetCouponsUseCase) {
  return function controller({ couponId }: ControllerArgs): ReturnType<IGetCouponsUseCase['execute']> {
    return getCouponsUseCase.execute({ couponId });
  };
}
